import { render, staticRenderFns } from "./BackgroundDownloader.vue?vue&type=template&id=0c0a2b3c&scoped=true&"
import script from "./BackgroundDownloader.vue?vue&type=script&lang=js&"
export * from "./BackgroundDownloader.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundDownloader.vue?vue&type=style&index=0&id=0c0a2b3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a2b3c",
  null
  
)

export default component.exports